import React, { Component } from 'react';
import { Table, Image, List } from 'semantic-ui-react';
import RarityLink from '../../common/RarityLink';
import ItemDetailCell from './ItemDetailCell';
import ItemStatsList from './ItemStatsList';

class ItemTableHeaderRow extends Component {

    render() {
        return (
            <Table.Row>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Category</Table.HeaderCell>
                <Table.HeaderCell width={1} textAlign='center'>Level</Table.HeaderCell>
                <Table.HeaderCell>Details</Table.HeaderCell>
            </Table.Row>
        )
    }
};

class ItemTableRow extends Component {

    render() {
        const { item } = this.props;

        const statsGrid = (item.Rune || item.Equipment) ?
            <List.Item><ItemStatsList item={item} /></List.Item> :
            null;

        return (
            <Table.Row>
                <Table.Cell collapsing>
                    <Image src={`\\images\\${item.Icon}.png`} rounded/>
                </Table.Cell>
                <Table.Cell verticalAlign='middle'>
                    <List divided>
                        <List.Item>
                            <List.Content>
                                <List.Header>
                                    <RarityLink to={`items/${item.ItemKey}`} rarity={item.Rarity}>
                                        {item.Name.English}
                                    </RarityLink>
                                </List.Header>
                                <List.Description style={{paddingTop: '5px'}}>
                                    <small>{item.Description ? item.Description.English : ''}</small>
                                </List.Description>
                            </List.Content>
                        </List.Item>
                        {statsGrid}
                    </List>
                </Table.Cell>
                <Table.Cell>
                    {item.Category}
                </Table.Cell>
                <Table.Cell textAlign='center'>
                    {item.RequiredLevel}
                </Table.Cell>
                <Table.Cell>
                    <ItemDetailCell item={item}/>
                </Table.Cell>
            </Table.Row>
        );
    }
};

export { ItemTableHeaderRow, ItemTableRow };


// WEBPACK FOOTER //
// ./src/items/index/ItemTableRow.jsx